import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.to-fixed.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "products"
};
var _hoisted_2 = {
  class: "customized-header d-flex flex-row fl-s-b"
};
var _hoisted_3 = {
  class: "header-title d-flex fl-col fl-j-c"
};
var _hoisted_4 = {
  class: "customized-body"
};
var _hoisted_5 = {
  style: {
    "padding": "20px"
  }
};
var _hoisted_6 = {
  class: "body-wrapper"
};
var _hoisted_7 = {
  class: "input-wrapper"
};
var _hoisted_8 = {
  class: "products-table-wrapper"
};
var _hoisted_9 = {
  class: "products-table"
};
var _hoisted_10 = {
  class: "products-table-header"
};
var _hoisted_11 = {
  class: "products-table-cell",
  style: {
    "width": "130px"
  }
};
var _hoisted_12 = {
  class: "products-table-cell"
};
var _hoisted_13 = {
  class: "products-table-cell"
};
var _hoisted_14 = {
  class: "products-table-cell"
};
var _hoisted_15 = {
  class: "products-table-cell"
};

var _hoisted_16 = /*#__PURE__*/_createElementVNode("th", {
  class: "products-table-cell",
  style: {
    "width": "220px"
  }
}, null, -1);

var _hoisted_17 = {
  class: "products-table-body"
};
var _hoisted_18 = {
  class: "products-table-cell",
  style: {
    "width": "130px"
  }
};
var _hoisted_19 = ["src"];
var _hoisted_20 = {
  class: "products-table-cell"
};
var _hoisted_21 = {
  key: 0,
  class: "tooltip"
};
var _hoisted_22 = {
  class: "tooltiptext"
};
var _hoisted_23 = {
  key: 1,
  class: "tooltip"
};
var _hoisted_24 = {
  class: "tooltiptext"
};
var _hoisted_25 = {
  class: "products-table-cell"
};
var _hoisted_26 = {
  key: 0,
  class: "tooltip"
};
var _hoisted_27 = ["innerHTML"];
var _hoisted_28 = ["innerHTML"];
var _hoisted_29 = {
  key: 1,
  class: "tooltip"
};
var _hoisted_30 = ["innerHTML"];
var _hoisted_31 = ["innerHTML"];
var _hoisted_32 = {
  class: "products-table-cell"
};
var _hoisted_33 = {
  key: 0,
  class: "text-center"
};
var _hoisted_34 = {
  class: "products-table-cell"
};
var _hoisted_35 = {
  class: "text-center word-alignment"
};
var _hoisted_36 = {
  class: "products-table-cell",
  style: {
    "width": "220px"
  }
};
var _hoisted_37 = ["onClick", "disabled"];
var _hoisted_38 = ["id"];
var _hoisted_39 = {
  key: 0,
  class: "pss-quantity"
};
var _hoisted_40 = ["onMousedown", "onMouseup", "onTouchstart", "onTouchend", "disabled"];
var _hoisted_41 = {
  key: 0
};
var _hoisted_42 = {
  key: 1
};
var _hoisted_43 = {
  key: 2,
  class: "pss-quantity"
};
var _hoisted_44 = {
  class: "date-picker",
  ref: "datePickerContainer"
};
var _hoisted_45 = {
  class: "d-flex flex-row fl-j-c mt-10"
};
var _hoisted_46 = {
  style: {
    "width": "160px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_el_input = _resolveComponent("el-input");

  var _component_el_date_picker = _resolveComponent("el-date-picker");

  var _component_el_pagination = _resolveComponent("el-pagination");

  var _component_el_option = _resolveComponent("el-option");

  var _component_el_select = _resolveComponent("el-select");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.modalVisible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return _ctx.modalVisible = $event;
    }),
    "close-on-click-modal": true,
    "close-on-press-escape": true,
    "show-close": false,
    fullscreen: true,
    "custom-class": "orders-modal"
  }, {
    header: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("button.products")), 1)])]), _createElementVNode("div", {
        class: "close-button d-flex fl-col fl-j-c",
        onClick: _cache[0] || (_cache[0] = //@ts-ignore
        function () {
          return _ctx.close && _ctx.close.apply(_ctx, arguments);
        })
      }, [_createVNode(_component_SvgIcon, {
        iconContent: _ctx.closeIcon,
        iconAlt: _ctx.$t('button.close'),
        "icon-style": "width: 30px; height: 30px; filter: contrast(170%) invert(100%);"
      }, null, 8, ["iconContent", "iconAlt"])])])];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_input, {
        class: "search-products-input",
        size: "large",
        placeholder: _ctx.$t('products.placeholder'),
        clearable: "",
        type: "text",
        modelValue: _ctx.searchQuery,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return _ctx.searchQuery = $event;
        }),
        onInput: _ctx.updateProducts,
        debounce: "300"
      }, null, 8, ["placeholder", "modelValue", "onInput"])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("table", _hoisted_9, [_createElementVNode("thead", _hoisted_10, [_createElementVNode("tr", null, [_createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("products.image")), 1), _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("products.name")), 1), _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("products.description")), 1), _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("products.availability")), 1), _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("products.price")), 1), _hoisted_16])]), _createElementVNode("tbody", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedProducts, function (product) {
        return _openBlock(), _createElementBlock("tr", {
          key: product.id,
          class: "products-table-row"
        }, [_createElementVNode("td", _hoisted_18, [_createElementVNode("img", {
          src: _ctx.getPictureUrl(product) || require("@/assets/images/icons/shopping-icon.png")
        }, null, 8, _hoisted_19)]), _createElementVNode("td", _hoisted_20, [_ctx.getTranslationForProducts(product.nameLocale) === '' ? (_openBlock(), _createElementBlock("p", _hoisted_21, [_createTextVNode(_toDisplayString(product.name) + " ", 1), _createElementVNode("span", _hoisted_22, _toDisplayString(product.name), 1)])) : (_openBlock(), _createElementBlock("p", _hoisted_23, [_createTextVNode(_toDisplayString(_ctx.getTranslationForProducts(product.nameLocale)) + " ", 1), _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.getTranslationForProducts(product.nameLocale)), 1)]))]), _createElementVNode("td", _hoisted_25, [_ctx.getTranslationForProducts(product.descriptionLocale) === '' ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("p", {
          innerHTML: product.description
        }, null, 8, _hoisted_27), _createElementVNode("span", {
          class: "tooltiptext",
          innerHTML: product.description
        }, null, 8, _hoisted_28)])) : (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("p", {
          class: "clamped",
          innerHTML: _ctx.getTranslationForProducts(product.descriptionLocale)
        }, null, 8, _hoisted_30), _createElementVNode("span", {
          class: "tooltiptext",
          innerHTML: _ctx.getTranslationForProducts(product.descriptionLocale)
        }, null, 8, _hoisted_31)]))]), _createElementVNode("td", _hoisted_32, [!product.isRecurring ? (_openBlock(), _createElementBlock("p", _hoisted_33, [_createElementVNode("span", null, _toDisplayString(_ctx.isProductAvailable(product) || _ctx.countAvailability(product)), 1), _createTextVNode(" " + _toDisplayString(_ctx.$t("pcselect.left")), 1)])) : _createCommentVNode("", true)]), _createElementVNode("td", _hoisted_34, [_createElementVNode("p", _hoisted_35, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("common.from-semicolon")), 1), _createTextVNode(" " + _toDisplayString(" ".concat(product.product.currency, " ").concat((product.prices[0].value / 100).toFixed(2))), 1)])]), _createElementVNode("td", _hoisted_36, [product.isRecurring ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "select-product-btn",
          onClick: function onClick($event) {
            _ctx.selectProduct(null, product);

            _ctx.openCalendar(product.id);
          },
          disabled: !_ctx.canSell
        }, [_createElementVNode("div", {
          id: "selectButton-".concat(product.id)
        }, null, 8, _hoisted_38), _createTextVNode(" " + _toDisplayString(_ctx.$t("button.select")) + " ", 1), _ctx.productsPssCount[product.id] ? (_openBlock(), _createElementBlock("span", _hoisted_39, "X" + _toDisplayString(_ctx.productsPssCount[product.id]), 1)) : _createCommentVNode("", true)], 8, _hoisted_37)) : (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "select-product-btn",
          onMousedown: function onMousedown(event) {
            return _ctx.refreshPeriod(event, product);
          },
          onMouseup: function onMouseup(event) {
            return _ctx.selectProduct(event, product);
          },
          onTouchstart: function onTouchstart(event) {
            return _ctx.refreshPeriod(event, product);
          },
          onTouchend: function onTouchend(event) {
            return _ctx.selectProduct(event, product);
          },
          disabled: !_ctx.allowSelectProduct(product) || !_ctx.canSell
        }, [_ctx.allowSelectProduct(product) ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.$t("button.select")), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.$t("common.not-available")), 1)), _ctx.productsPssCount[product.id] ? (_openBlock(), _createElementBlock("span", _hoisted_43, " X" + _toDisplayString(_ctx.productsPssCount[product.id]), 1)) : _createCommentVNode("", true)], 40, _hoisted_40))])]);
      }), 128))])])])]), _createElementVNode("div", _hoisted_44, [_createVNode(_component_el_date_picker, {
        modelValue: _ctx.selectedDate,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return _ctx.selectedDate = $event;
        }),
        type: "date",
        onChange: _ctx.selectDate,
        ref: "datepicker",
        "disabled-date": _ctx.isDateDisabled
      }, null, 8, ["modelValue", "onChange", "disabled-date"])], 512), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", null, [_createVNode(_component_el_pagination, {
        layout: "prev, pager, next",
        total: _ctx.productsCount,
        "page-size": _ctx.pageSize,
        "current-page": _ctx.currentPage,
        onCurrentChange: _ctx.changeCurrentPage
      }, null, 8, ["total", "page-size", "current-page", "onCurrentChange"])]), _createElementVNode("div", _hoisted_46, [_createVNode(_component_el_select, {
        modelValue: _ctx.pageSize,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return _ctx.pageSize = $event;
        }),
        class: "w-100"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList([{
            value: 10,
            label: "10 ".concat(_ctx.$t('common.per-page'))
          }, {
            value: 25,
            label: "25 ".concat(_ctx.$t('common.per-page'))
          }, {
            value: 50,
            label: "50 ".concat(_ctx.$t('common.per-page'))
          }, {
            value: 100,
            label: "100 ".concat(_ctx.$t('common.per-page'))
          }], function (item) {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])])])])])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}